// extracted by mini-css-extract-plugin
module.exports = {"root":"Chat_root__LlKcj","messages":"Chat_messages__7BsB-","dateDivider":"Chat_dateDivider__23I0M"};